var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4512_13534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1716 3.375H2.04883C1.97148 3.375 1.9082 3.43828 1.9082 3.51562V4.5C1.9082 4.57734 1.97148 4.64062 2.04883 4.64062H16.1716C16.2489 4.64062 16.3122 4.57734 16.3122 4.5V3.51562C16.3122 3.43828 16.2489 3.375 16.1716 3.375ZM16.1716 8.36719H8.79883C8.72149 8.36719 8.6582 8.43047 8.6582 8.50781V9.49219C8.6582 9.56953 8.72149 9.63281 8.79883 9.63281H16.1716C16.2489 9.63281 16.3122 9.56953 16.3122 9.49219V8.50781C16.3122 8.43047 16.2489 8.36719 16.1716 8.36719Z",
    fill: "#000022",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79883 13.3594H16.2349C16.3122 13.3594 16.3755 13.4227 16.3755 13.5V14.4844C16.3755 14.5617 16.3122 14.625 16.2349 14.625H8.79883C8.72149 14.625 8.6582 14.5617 8.6582 14.4844V13.5C8.6582 13.4227 8.72149 13.3594 8.79883 13.3594Z",
    fill: "#000022",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78292 10.8092L2.06408 7.09039C1.93808 6.9644 1.72266 7.05363 1.72266 7.23181L1.72266 14.6695C1.72266 14.8477 1.93808 14.9369 2.06408 14.8109L5.78292 11.0921C5.86103 11.014 5.86103 10.8873 5.78292 10.8092Z",
    fill: "#000022",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4512_13534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpend);
export default __webpack_public_path__ + "static/media/expend.4d0a69a163e94cf2527846eee656d66d.svg";
export { ForwardRef as ReactComponent };